import { render, staticRenderFns } from "./dubletten-confirmation-table-compare-table.vue?vue&type=template&id=d012adb8&scoped=true"
import script from "./dubletten-confirmation-table-compare-table.vue?vue&type=script&lang=js"
export * from "./dubletten-confirmation-table-compare-table.vue?vue&type=script&lang=js"
import style0 from "./dubletten-confirmation-table-compare-table.vue?vue&type=style&index=0&id=d012adb8&prod&lang=scss&scoped=true"
import style1 from "./dubletten-confirmation-table-compare-table.vue?vue&type=style&index=1&id=d012adb8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d012adb8",
  null
  
)

export default component.exports